/** `document` module DTOs unique keys */
export enum DocumentDtoKeysEnum {
  /** ABC-analysis API response body */
  ABC_ANALYSIS_PAGE_DTO = 'document/abc-analysis-page.dto',
  /** ABC-analysis API query parameters */
  ABC_ANALYSIS_QUERY_DTO = 'document/abc-analysis-query.dto',
  /** ABC-analysis API report item */
  ABC_ANALYSIS_ROW_DTO = 'document/abc-analysis-row.dto',
  /** ABC-analysis widget API query parameters */
  ABC_ANALYSIS_WIDGET_QUERY_DTO = 'document/abc-analysis-widget-query.dto',
  /** Bank statement rule condition response body */
  BANK_STATEMENT_RULE_CONDITION_FIND_DTO = 'document/bank-statement-rule-condition-find.dto',
  /** Bank statement rule create and update API's condition request body */
  BANK_STATEMENT_RULE_CONDITION_FORM_DTO = 'document/bank-statement-rule-condition-form.dto',
  /** Bank statement rule expression response body */
  BANK_STATEMENT_RULE_EXPRESSION_FIND_DTO = 'document/bank-statement-rule-expression-find.dto',
  /** Bank statement rule create and update API's expression request body */
  BANK_STATEMENT_RULE_EXPRESSION_FORM_DTO = 'document/bank-statement-rule-expression-form.dto',
  /** Bank statement rule response body */
  BANK_STATEMENT_RULE_FIND_DTO = 'document/bank-statement-rule-find.dto',
  /** Bank statement rule create and update API's request body */
  BANK_STATEMENT_RULE_FORM_DTO = 'document/bank-statement-rule-form.dto',
  /** Cash-Flow Analysis widget API response body */
  CASH_FLOW_ANALYSIS_FIND_DTO = 'document/cash-flow-analysis-find.dto',
  /** Cash-Flow Analysis widget API query parameters */
  CASH_FLOW_ANALYSIS_QUERY_DTO = 'document/cash-flow-analysis-query.dto',
  /** Document exchange filter response body */
  DOCUMENT_EXCHANGE_FILTER_FIND_DTO = 'document/document-exchange-filter-find.dto',
  /** Document exchange filter create or update APIs request body */
  DOCUMENT_EXCHANGE_FILTER_FORM_DTO = 'document/document-exchange-filter-form.dto',
  DOCUMENT_HISTORY_FIND_DTO = 'document/document-history-find.dto',
  DOCUMENT_HISTORY_PAGE_DTO = 'document/document-history-page.dto',
  OPERATION_TYPE_HISTORY_FIND_DTO = 'document/operation-type-history-find.dto',
  OPERATION_TYPE_HISTORY_PAGE_DTO = 'document/operation-type-history-page.dto',
  /** Operation type base filters */
  OPERATION_TYPE_FILTERS_DTO = 'document/operation-type-filters.dto',
  /** Operation type find one API additional options */
  OPERATION_TYPE_FIND_ONE_OPTIONS_DTO = 'document/operation-type-find-one-options.dto',
  OPERATION_TYPE_FIND_ALL_QUERY_DTO = 'document/operation-type-find-all-query.dto',
  OPERATION_TYPE_FIND_PAGE_QUERY_DTO = 'document/operation-type-find-page-query.dto',
  /** Operation type response body */
  OPERATION_TYPE_FIND_DTO = 'document/operation-type-find.dto',
  OPERATION_TYPE_FORM_DTO = 'document/operation-type-form.dto',
  OPERATION_TYPE_PAGE_DTO = 'document/operation-type-page.dto',
  DOCUMENT_TYPE_HISTORY_FIND_DTO = 'document/document-type-history-find.dto',
  DOCUMENT_TYPE_HISTORY_PAGE_DTO = 'document/document-type-history-page.dto',
  DOCUMENT_COMPARE_QUERY_DTO = 'document/document-compare-query.dto',
  DOCUMENT_COMPARE_AMOUNT_DTO = 'document/document-compare-amount.dto',
  DOCUMENT_COMPARE_RESULT_DTO = 'document/document-compare-result.dto',
  DOCUMENT_COMPARE_ITEM_DTO = 'document/document-compare-item.dto',
  DOCUMENT_COMPARE_REPORT_DTO = 'document/document-compare-report.dto',
  CONTRACT_1C_SYNC_QUERY_DTO = 'document/contract-1c-sync-query.dto',
  CONTRACT_FIND_DTO = 'document/contract-find.dto',
  CONTRACT_FORM_DTO = 'document/contract-form.dto',
  CONTRACT_CREATE_DTO = 'document/contract-create.dto',
  /** Contract list APIs base filters */
  CONTRACT_FILTERS_DTO = 'document/contract-filters.dto',
  /** Contract find one API additional query parameters */
  CONTRACT_FIND_ONE_QUERY_DTO = 'document/contract-find-one-query.dto',
  CONTRACT_QUERY_DTO = 'document/contract-query.dto',
  CONTRACT_PAGE_DTO = 'document/contract-page.dto',
  CONTRACT_HISTORY_FIND_DTO = 'document/contract-history-find.dto',
  CONTRACT_HISTORY_PAGE_DTO = 'document/contract-history-page.dto',
  CONTRACT_SWITCH_STATUS_DTO = 'document/contract-switch-status.dto',
  CONTRACT_1C_SYNC_ITEM_DTO = 'document/contract-1c-sync-item.dto',
  CONTRACT_1C_SYNC_RESULT_DTO = 'document/contract-1c-sync-result.dto',
  SALARY_DISTRIBUTION_USER_FIND_DTO = 'document/salary-distribution-user-find.dto',
  SALARY_DISTRIBUTION_USER_FORM_DTO = 'document/salary-distribution-user-form.dto',
  SALARY_DISTRIBUTION_DIRECTION_SETTINGS_FORM_DTO = 'document/salary-distribution-direction-settings-form.dto',
  SALARY_DISTRIBUTION_UNIT_SETTINGS_FORM_DTO = 'document/salary-distribution-unit-settings-form.dto',
  SALARY_DISTRIBUTION_FILIAL_SETTINGS_FORM_DTO = 'document/salary-distribution-filial-settings-form.dto',
  SALARY_DISTRIBUTION_ANALYTICAL_FEATURE_SETTINGS_DTO = 'document/salary-distribution-analytical-feature-settings.dto',
  SALARY_DISTRIBUTION_FIND_DTO = 'document/sale-distribution-find.dto',
  SALARY_DISTRIBUTION_FORM_DTO = 'document/sale-distribution-form.dto',
  SALARY_DISTRIBUTION_QUERY_DTO = 'document/salary-distribution-query.dto',
  SALARY_DISTRIBUTION_PAGE_DTO = 'document/salary-distribution-page.dto',
  SALARY_DISTRIBUTION_STAT_ITEM_DTO = 'document/salary-distribution-stat-item.dto',
  SALARY_DISTRIBUTION_STAT_DTO = 'document/salary-distribution-stat.dto',
  /** Documents bulk create API request body */
  DOCUMENT_BULK_CREATE_DTO = 'document/document-bulk-create.dto',
  /** Documents bulk update API item request body */
  DOCUMENT_BULK_FORM_DTO = 'document/document-bulk-form.dto',
  /** Documents bulk update API request body */
  DOCUMENT_BULK_UPDATE_DTO = 'document/document-bulk-update.dto',
  /** Document create API request body */
  DOCUMENT_CREATE_DTO = 'document/document-create.dto',
  /** Document registry and statistics APIs common filters */
  DOCUMENT_FILTERS_DTO = 'document/document-filters.dto',
  /** Document response body */
  DOCUMENT_FIND_DTO = 'document/document-find.dto',
  /** Document type create API request body */
  DOCUMENT_TYPE_CREATE_DTO = 'document/document-type-create.dto',
  /** Document types list API base filters */
  DOCUMENT_TYPE_FILTERS_DTO = 'document/document-type-filters.dto',
  /** Document type response body */
  DOCUMENT_TYPE_FIND_DTO = 'document/document-type-find.dto',
  /** Document type create and update APIs request body */
  DOCUMENT_TYPE_FORM_DTO = 'document/document-type-form.dto',
  /** Document type single CRUD APIs URL parameters */
  DOCUMENT_TYPE_PARAMS_DTO = 'document/document-type-params.dto',
  /** Document types list API query parameters */
  DOCUMENT_TYPE_QUERY_DTO = 'document/document-type-query.dto',
  /** Document's flat list and statistics query parameters */
  DOCUMENT_FLAT_QUERY_DTO = 'document/document-flat-query.dto',
  /** Document create/update APIs request body */
  DOCUMENT_FORM_DTO = 'document/document-form.dto',
  /** Document registry API response body */
  DOCUMENT_PAGE_DTO = 'document/document-page.dto',
  /** Single document APIs URL parameters */
  DOCUMENT_PARAMS_DTO = 'document/document-params.dto',
  /** Document's list with pagination API query parameters */
  DOCUMENT_QUERY_DTO = 'document/document-query.dto',
  /** Documents bulk deletion API request body */
  DOCUMENT_MULTIPLE_DELETE_DTO = 'document/document-multiple-delete.dto',
  /** Document split API request body item */
  DOCUMENT_SPLIT_CHUNK_DTO = 'document/document-split-chunk.dto',
  /** Document split API request body */
  DOCUMENT_SPLIT_DTO = 'document/document-split.dto',
  /** Document statistics API response body */
  DOCUMENT_STATISTICS_DTO = 'document/document-statistics.dto',
  /** Document template response body */
  DOCUMENT_TEMPLATE_FIND_DTO = 'document/document-template-find.dto',
  /** Document template create/update request body */
  DOCUMENT_TEMPLATE_FORM_DTO = 'document/document-template-form.dto',
  /** Document template search API query parameters */
  DOCUMENT_TEMPLATE_SEARCH_QUERY_DTO = 'document/document-template-search-query.dto',
  /** Document verify API parameters */
  DOCUMENT_VERIFY_BODY_DTO = 'document/document-verify-body.dto',
  /** Document verify API event entry */
  DOCUMENT_VERIFY_ENTRY_DTO = 'document/document-verify-entry.dto',
  /** Document verify API response body */
  DOCUMENT_VERIFY_RESULT_DTO = 'document/document-verify-result.dto',
  /** Document verify summary data (count and amount) response body */
  DOCUMENT_VERIFY_SUMMARY_DATA_DTO = 'document/document-verify-summary-data.dto',
  /** Document verify summary by entity table row response body */
  DOCUMENT_VERIFY_SUMMARY_ROW_DTO = 'document/document-verify-summary-row.dto',
  /** Document verify summary by entity table response body */
  DOCUMENT_VERIFY_SUMMARY_TABLE_DTO = 'document/document-verify-summary-table.dto',
  /** Document verify summary response body */
  DOCUMENT_VERIFY_SUMMARY_DTO = 'document/document-verify-summary.dto',
  BILL_FIND_DTO = 'document/bill-find.dto',
  /** Bill create and update APIs request body */
  BILL_FORM_DTO = 'document/bill-form.dto',
  BILL_LIST_QUERY_DTO = 'document/bill-list-query.dto',
  BILL_PAGE_QUERY_DTO = 'document/bill-page-query.dto',
  BILL_PAGE_DTO = 'document/bill-page.dto',
  BILL_STATISTICS_DTO = 'document/bill-statistics.dto',
  /** Bill verify API query parameters */
  BILL_VERIFY_QUERY_DTO = 'document/bill-verify-query.dto',
  /** Bill verify API response body item */
  BILL_VERIFY_RESULT_ITEM_DTO = 'document/bill-verify-result-item.dto',
  /** Credit/Debit dynamics report APIs base filters */
  CREDIT_DEBIT_DYNAMICS_REPORT_FILTERS_DTO = 'document/credit-debit-dynamics-report-filters.dto',
  CREDIT_DEBIT_DYNAMICS_REPORT_ITEM_DTO = 'document/credit-debit-dynamics-report-item.dto',
  CREDIT_DEBIT_DYNAMICS_REPORT_DTO = 'document/credit-debit-dynamics-report.dto',
  CREDIT_DEBIT_DYNAMICS_REPORT_TOTAL_DTO = 'document/credit-debit-dynamics-report-total.dto',
  /** Credit/Debit dynamics report APIs query parameters */
  CREDIT_DEBIT_DYNAMICS_REPORT_QUERY_DTO = 'document/credit-debit-dynamics-report-query.dto',
  /** Credit/Debit exclusion response body */
  CREDIT_DEBIT_EXCLUSION_FIND_DTO = 'document/credit-debit-exclusion-find.dto',
  /** Credit/Debit exclusion create and update APIs request body */
  CREDIT_DEBIT_EXCLUSION_FORM_DTO = 'document/credit-debit-exclusion-form.dto',
  /** Contragent which must be created to save pending documents */
  BANK_STATEMENT_CONTRAGENT_FORM_DTO = 'document/bank-statement-contragent-form.dto',
  /** Pending documents submit form */
  BANK_STATEMENT_PENDING_DOCUMENTS_FORM_DTO = 'document/bank-statement-pending-documents-form.dto',
  /** Company which must be created to save pending documents */
  BANK_STATEMENT_COMPANY_FORM_DTO = 'document/bank-statement-company-form.dto',
  /** Company which must be created to save pending documents */
  BANK_STATEMENT_COMPANY_CREATE_FIND_DTO = 'document/bank-statement-company-create-find.dto',
  /** Data about document to create on contragents and companies submit */
  BANK_STATEMENT_DOCUMENT_FORM_DTO = 'document/bank-statement-document-form.dto',
  /** Contragent which must be created to save pending documents */
  BANK_STATEMENT_CONTRAGENT_CREATE_FIND_DTO = 'document/bank-statement-contragent-create-find.dto',
  /** Pending documents - contains contragents and companies which must be created by user before related documents will be created */
  BANK_STATEMENT_PENDING_DOCUMENTS_FIND_DTO = 'document/bank-statement-pending-documents-find.dto',
}
